import QtyCellLabelText from './QtyCellLabelText'
export default QtyCellLabelText
